<template lang="pug">
  #app.clearfix
    navbar.clearfix.navbar.navbar-default(
      v-if="authed && $route.path !== '/login'"
      placement='top'
      type='default')
      a.navbar-brand(slot='brand' v-link="{name: 'index'}")
        b
          span Eagle
          span.glyphicon.glyphicon-eye-open
      li
        a(v-link="{path: '/dashboard'}")
          i.glyphicon.glyphicon-dashboard
          |  Dashboard
      dropdown
        a.dropdown-toggle.clickable(slot="button" type="button")
          span.glyphicon.glyphicon-user
          |  Users 
          span.caret
        ul(slot="dropdown-menu" class="dropdown-menu")
          li
            a(v-link="{path: '/users/overview'}")
              i.glyphicon.glyphicon-globe
              |  Overview
          li
            a(v-link="{path: '/users/activities'}")
              i.glyphicon.glyphicon-calendar
              |  Activity
          //- li
            a(v-link="{path: '/users/geo'}")
              i.glyphicon.glyphicon-map-marker
              |  GEO Distribution
      li
        a(v-link="{path: '/devices/overview'}")
          i.glyphicon.glyphicon-hdd
          |  Devices
      //- dropdown(text='Devices')
        a.dropdown-toggle.clickable(slot="button" type="button")
          span.glyphicon.glyphicon-hdd
          |  Devices 
          span.caret
        li
          a(v-link="{path: '/devices/overview'}")
            i.glyphicon.glyphicon-globe
            |  Overview
        li
          a(v-link="{path: '/devices/activities'}")
            i.glyphicon.glyphicon-calendar
            |  Activity
        li
          a(v-link="{path: '/devices/geo'}")
            i.glyphicon.glyphicon-map-marker
            |  GEO Distribution
      li.disabled
        a(v-link="{path: '/issues'}")
          i.glyphicon.glyphicon-alert
          |  Issues
      dropdown(disabled="true")
        a.dropdown-toggle.clickable(slot="button" type="button")
          span.glyphicon.glyphicon-scale
          |  Analytics 
          span.caret
        li
          a(v-link="{path: '/analytics/issue_analytics'}")
            | Issue analytics
        li
          a(v-link="{path: '/analytics/user_activities'}")
            | User activities
        li
          a(v-link="{path: '/analytics/device_usage'}")
            | Device usage
        li
          a(v-link="{path: '/analytics/event_analytics'}")
            | Event analytics
      dropdown(disabled="true")
        a.dropdown-toggle.clickable(slot="button" type="button")
          span.glyphicon.glyphicon-send
          |  Newsletter 
          span.caret
        li
          a(v-link="{path: '/news_letter/write_announcememnt'}")
            | Write announcement
        li
          a(v-link="{path: '/news_letter/announce_firmware'}")
            | Announce firmware
        li
          a(v-link="{path: '/news_letter/history'}")
            | History
      dropdown(v-bind:text='user.email' slot='right')
        li
          a(@click="logout")
            i.fa.fa-sign-out
            | &nbsp;Logout
        li
          a Ver. {{ version }}
    .main
      router-view
    alert(
      v-bind:type="alertData.type"
      v-bind:show.sync="alertData.show"
      v-bind:duration="1000"
      width="280px"
      placement="top-right"
      dismissable)
      span.icon-ok-circled.alert-icon-float-left
      strong {{ alertData.title }}
      p {{ alertData.content }}
</template>

<script>
import { navbar, dropdown, alert } from 'vue-strap'
import { version } from '../package.json'
import { firebaseLogout } from './index'
import { AUTH_STATE_AUTHED } from './store'

export default {
  components: {
    navbar,
    dropdown,
    alert
  },
  data: () => ({
    version,
    alertList: [],
    alertData: {
      type: '',
      title: '',
      show: false,
      content: ''
    }
  }),
  vuex: {
    getters: {
      user: state => state.user,
      authed: state => state.authState === AUTH_STATE_AUTHED
    }
  },
  methods: {
    logout () {
      firebaseLogout().then(() => {
        // this.alert('success', '', 'Logout Success')
        this.$router.replace('/login')
      })
    },
    alert ({type, title, content}) {
      console.log(type)
      console.log(title)
      console.log(content)
      let newAlert = {
        type,
        title,
        content,
        show: true
      }
      this.alertList.push(newAlert)
    }
  },
  events: {
    alert (e) {
      console.log(e)
      this.alert(e)
    }
  },
  ready () {
    setInterval(() => {  // make alerts wait in list
      if (this.alertList.length) {
        this.alertData = this.alertList.shift()
        this.alertData.show = false
        setTimeout(() => {
          this.alertData.show = true
        }, 1500)
      }
    }, 2000)
  }
}
</script>

<style lang='scss'>
@import './scss/main.scss';
@import "~font-awesome/css/font-awesome.min.css";

html {
  height: 100%;
}

body {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

#app {
  width: 100vw;
  height:  100vh;
}
.main {
  margin-top: 40px;
}

</style>



// WEBPACK FOOTER //
// App.vue?228e2613